// extracted by mini-css-extract-plugin
export default {"container":"header_container__Kv0zV","buttons":"header_buttons__Ma8Zl","logo":"header_logo__ts5xN","logoText":"header_logoText__I0ALu"};